import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

import ShortInfo from './../block/ShortInfo'
import Cards1 from './../block/Cards1'
import KatalogDlaBani from './../block/KatalogDlaBani'
import PosmotriteVideo from './../block/PosmotriteVideo'
import HideContentBlock from './../block/HideContentBlock'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'

class OknaDlyaBani extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.priemushestva || []}
        />
        <KatalogDlaBani
          list={data?.katalog || []}
          assets_path={assets_path}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <PosmotriteVideo
          data={data?.videos || {}}
          assets_path={assets_path}
        />
        <HideContentBlock
          data={data?.hidecontent || {}}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

OknaDlyaBani.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

OknaDlyaBani.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default OknaDlyaBani